/**
 * Valida si un string contiene un formato de correo electrónico válido.
 * Utiliza una expresión regular estándar compatible con RFC 5322 básica.
 *
 * @param correo Correo a validar
 * @returns true si el correo no está vacío y cumple el formato; false en caso contrario
 */
export const esCorreoValido = (correo?: string | null): boolean => {
  if (!correo) return false;
  const trimmed = correo.trim();
  if (trimmed.length === 0) return false;
  
  // Regex estándar para validación de formato de correo
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(trimmed);
};
